import Modal from '../Modal'
import BookingForm from '../BookingForm'
import { useEffect } from 'react'

export default function BookingModal({ productId, modalIsOpen, setModalIsOpen }) {

    useEffect(() => {

        console.log("Running for product ID")

    }, [productId])


    return (
        <Modal modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen}>
            <BookingForm productId={productId} />
        </Modal>
    )


}